import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import React__default from 'react';
import classNames from 'classnames';
import styles from './230f48bca895ae75ee29ab7b639ad5462876241d350c2037bfd6bdb365423a3e.cfe-internal.js';
import ConditionSet from './95e9bf1e91f2873bd9a2cc9ed8f00ff45d4237b18177212e3650c49b49aa1a96.cfe-internal.js';
import { SET_VALUE_ANY, constructValidDefaultState, shallowCopy, getParentSet } from './05a657b89c4e3b2985613913e27c531d51aad8696a81c63eaa65a9959b1f6913.cfe-internal.js';
import { LogicEditorContextProvider } from './587a9c6736e7e443901f9bfa68401f276eb4b68d9d52fe6cf57f5f9d8d2114b6.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';

var _excluded = ["className", "conditionTemplate", "defaultSetValue", "defaultValue", "fixedSet", "onChange", "readOnly", "maxNestedSets", "firstFocusableElementRef", "data-testid"];
var LogicEditor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    conditionTemplate = _ref.conditionTemplate,
    _ref$defaultSetValue = _ref.defaultSetValue,
    defaultSetValue = _ref$defaultSetValue === void 0 ? SET_VALUE_ANY : _ref$defaultSetValue,
    defaultValue = _ref.defaultValue,
    fixedSet = _ref.fixedSet,
    onChange = _ref.onChange,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$maxNestedSets = _ref.maxNestedSets,
    maxNestedSets = _ref$maxNestedSets === void 0 ? 2 : _ref$maxNestedSets,
    firstFocusableElementRef = _ref.firstFocusableElementRef,
    dataTestId = _ref['data-testid'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var translations = {
    any: translate('logicEditor.any'),
    all: translate('logicEditor.all'),
    insertConditionBelow: translate('logicEditor.insertConditionBelow'),
    insertSetBelow: translate('logicEditor.insertSetBelow'),
    "delete": translate('logicEditor.delete'),
    conditionActions: translate('logicEditor.conditionActions')
  };
  var _React$useState = React__default.useState(constructValidDefaultState({
      defaultValue: defaultValue,
      defaultSetValue: defaultSetValue,
      fixedSet: fixedSet,
      maxNestedSets: maxNestedSets
    })),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var classes = classNames(className, styles.editor);
  function update(newState) {
    setState(newState);
    onChange === null || onChange === void 0 || onChange(newState);
  }
  var handleNewLogicItem = function handleNewLogicItem(item, position) {
    var _context;
    var newState = shallowCopy(state);
    var parent = getParentSet(newState, position);
    _spliceInstanceProperty(_context = parent.conditions).call(_context, position.index, 0, item);
    update(newState);
  };
  var handleSetChange = function handleSetChange(newSetValue, position) {
    var rootState = shallowCopy(state);
    var parent = getParentSet(rootState, position);
    if (!position.parent) {
      // root set
      parent.value = newSetValue;
    } else {
      parent.conditions[position.index].value = newSetValue;
    }
    update(rootState);
  };
  var handleConditionChange = function handleConditionChange(newCondition, position) {
    var newState = shallowCopy(state);
    var parent = getParentSet(newState, position);
    parent.conditions[position.index] = newCondition;
    update(newState);
  };
  var handleDelete = function handleDelete(position) {
    var _context2;
    var newState = shallowCopy(state);
    var parent = getParentSet(newState, position);
    _spliceInstanceProperty(_context2 = parent.conditions).call(_context2, position.index, 1);

    // If the last condition in a set was deleted, also delete the set.
    if (parent.conditions.length === 0) {
      var _context3;
      _spliceInstanceProperty(_context3 = getParentSet(newState, position.parent).conditions).call(_context3, position.parent.index, 1);
    }
    update(newState);
  };
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    role: "group",
    className: classes,
    ref: ref,
    "data-testid": dataTestId
  }), /*#__PURE__*/React__default.createElement(LogicEditorContextProvider, {
    value: {
      onNewLogicItem: handleNewLogicItem,
      onSetChange: handleSetChange,
      onConditionChange: handleConditionChange,
      onDelete: handleDelete,
      defaultSetValue: defaultSetValue,
      fixedSet: fixedSet,
      conditionTemplate: conditionTemplate,
      translations: translations,
      maxNestedSets: maxNestedSets,
      readOnly: readOnly,
      rootDataTestId: dataTestId
    }
  }, /*#__PURE__*/React__default.createElement(ConditionSet, {
    value: state,
    level: 0,
    index: 0,
    firstFocusableElementRef: firstFocusableElementRef
  })));
});

export { LogicEditor as default };
